import { IPdfMedia } from "@types";
import { BaseAPI } from "@utils";

class PdfMediaApi extends BaseAPI<IPdfMedia> { }
export const pdfMediaApi = new PdfMediaApi("/api/v1/media/pdf");
